const DEFAULT_CHAR_LIMIT = 20;

export const joinWordsWithLimit = (
  words: string[],
  limit: number = DEFAULT_CHAR_LIMIT,
): string => {
  let charCount = 0;
  let isLimited = false;

  return words
    .map((word) => {
      if (charCount < limit) {
        charCount += word.length;

        if (charCount >= limit) {
          isLimited = true;
        }

        return word;
      }

      if (!isLimited) {
        isLimited = true;
        return word;
      }

      return null;
    })
    .filter(Boolean)
    .join(' ');
};
